import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import moment from "moment";
import TableContainer from '../../Components/Common/TableContainer';
import { userTransactionListApi } from '../../pages/User/_requests';
import { formatDate } from '../../helpers/FunctionHelpers';

interface Transaction {
  id: number;
  transaction_id: string;
  user_id: number;
  wallet_id: number;
  transaction_type: string;
  order_id: number | null;
  user_subscription_id: number | null;
  credit: number;
  debit: number;
  balance: string;
  payment_status: string;
  created_at: string;
  updated_at: string;
  user: {
    id: number;
    name: string;
    email: string;
  };
  order: {
    id: number;
    order_code_id: string;
    total_amount: string;
  } | null;
  userSubscription: {
    id: number;
    gross_amount: string;
    subscription?: {
      name?: string;
    }
  } | null;
}

const TransactionsList = () => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        setLoading(true);
        const data = { user_id: "" }
        const response = await userTransactionListApi(data);
        console.log("response userTransactionListApi", response)
        if (response.status && response.data) {
          setTransactions(response.data);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  // Column
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "serial",
        enableSorting: false,
        enableColumnFilter: false,
        cell: (cell: any) => {
          const { pageIndex, pageSize } = cell.table.getState().pagination;
          const serialNumber = pageIndex * pageSize + cell.row.index + 1;
          return <span>{serialNumber}</span>;
        },
      },
      {
        header: "Transaction ID",
        accessorKey: "transaction_id",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const transaction = cell.row.original;
          const id = transaction.order_id || transaction.user_subscription_id;
          const type = transaction.order_id ? 'order' : 'subscription';

          return (
            <p className="fw-medium link-primary">   {transaction.transaction_id}</p>
            // <Link to={`/${type}s/view/${id}`} className="fw-medium link-primary">
            //   {transaction.transaction_id}
            // </Link>
          );
        },
      },
      {
        header: "Date & Time",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const date = cell.getValue();
          return (
            <>
                {formatDate(date)},
            </>
          );
        },
      },
      {
        header: "Type",
        accessorKey: "transaction_type",
        enableColumnFilter: false,
        cell: ({ row }: any) => {
          const transaction = row.original;
          let text = "Unknown";
          let style: React.CSSProperties = { fontWeight: "normal" };

          if (transaction.order_id) {
            text = "Order";
            style = { color: "blue", fontWeight: "bold" };
          } else if (transaction.user_subscription_id) {
            text = "Subscription";
            style = { color: "green", fontWeight: "bold" };
          }

          return <span style={style}>{text}</span>;
        },
      },
      {
        header: "User",
        accessorKey: "user.name",
        enableColumnFilter: false,
      },
      {
        header: "Reference",
        enableColumnFilter: false,
        cell: ({ row }: any) => {
          const transaction = row.original;
          if (transaction.order) {
            return ` ${transaction.order.order_code_id}`;
          } else if (transaction.userSubscription) {
            return `${transaction.userSubscription?.subscription?.name}`;
          }
          return "-";
        },
      },
      {
        header: "Amount",
        enableColumnFilter: false,
        cell: ({ row }: any) => {
          const transaction = row.original;
          const amount = transaction.order?.total_amount || transaction.userSubscription?.gross_amount || "0.00";
          return `₹${parseFloat(amount).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        },
      },
  
      {
        header: "Status",
        accessorKey: "payment_status",
        enableColumnFilter: false,
        cell: ({ row }: any) => {
          const status = row.original.payment_status;
          const statusMap: Record<string, { class: string }> = {
            "COMPLETED": { class: "bg-success-subtle text-success" },
            "PENDING": { class: "bg-warning-subtle text-warning" },
            "FAILED": { class: "bg-danger-subtle text-danger" },
          };

          const statusClass = statusMap[status]?.class || "bg-secondary-subtle text-secondary";

          return (
            <span className={`badge fw-bold fs-7 ${statusClass}`}>
              {status}
            </span>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <Card>
        <CardHeader className="card-header border-0">
          <Row className="align-items-center gy-3">
            <div className="col-sm">
              <h5 className="card-title mb-0">Recent Transactions</h5>
            </div>
          </Row>
        </CardHeader>
        <CardBody>
          <div>
            {transactions?.length ? (
              <TableContainer
                columns={columns}
                data={transactions || []}
                customPageSize={10}
                divClass="table-responsive table-card mb-1 mt-0"
                tableClass="align-top table-bordered align-top table-nowrap"
                theadClass="table-light text-muted text-uppercase"
              />
            ) : (
              <p className="fw-bold text-center">No Transactions Found</p>
            )}
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default TransactionsList;